function buildMenu (allowed) {
  let menu = []
  if (allowed == null || allowed.includes('Tasks'))  {
    menu = [
    {
      title: 'Tasks',
      icon: 'mdi-calendar',
      items: [
        {
          title: 'Calendar', 
          icon: 'mdi-calendar-range-outline',
          path: '/SchCalendar'}
      ]
    }
  ] 
} 
  
  return menu
}

export default buildMenu